/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {Col, FormControl as BootstrapFormControl, Row} from 'react-bootstrap';
import FormGroup from '../FormGroup';
import FormControl from '../FormControl';
import Props from './Props';
import {parseCountryString} from '../../model/country';

class PhoneNumberLookup extends React.Component<Props> {

	static defaultProps: Props = {
		autoFocus: false,
		disabled: false,
		lookupValue: {country: 'NETHERLANDS', phoneNumber: ''},
		onChange: () => {
			// do nothing
		},
		onEnter: () => {
			// do nothing
		},
		violations: []
	};

	handleCountryChange = (event: React.FormEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>): void => {
		const props: Readonly<Props> = this.props;

		props.onChange(parseCountryString(String(event.currentTarget.value)), props.lookupValue.phoneNumber);
	};

	handlePhoneNumberChange = (event: React.FormEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>): void => {
		const props: Readonly<Props> = this.props;

		props.onChange(props.lookupValue.country, String(event.currentTarget.value));
	};

	handlePhoneNumberEnter = (): void => {
		const props: Readonly<Props> = this.props;

		props.onEnter(props.lookupValue.country, props.lookupValue.phoneNumber);
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<React.Fragment>
				<Row>
					<Col xs={12} sm={3}>
						<FormGroup controlId="country" label="Land:">
							<BootstrapFormControl
								as="select"
								value={props.lookupValue.country}
								onChange={this.handleCountryChange}
								disabled={props.disabled}>
								<option value="NETHERLANDS">NL (+31)</option>
								<option value="BELGIUM">BE (+32)</option>
								<option value="GERMANY">DE (+49)</option>
								<option value="UKRAINE">UA (+380)</option>
								<option value="ROMANIA">RO (+40)</option>
							</BootstrapFormControl>
						</FormGroup>
					</Col>
					<Col xs={12} sm={9}>
						<FormGroup controlId="phoneNumber" label="Telefoonnummer:" violations={props.violations}>
							<FormControl
								autoFocus={props.autoFocus}
								disabled={props.disabled}
								onChange={this.handlePhoneNumberChange}
								onEnter={this.handlePhoneNumberEnter}
								placeholder="Telefoonnummer"
								type="text"
								isInvalid={props.violations.length > 0}
								value={props.lookupValue.phoneNumber}/>
						</FormGroup>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}

export default PhoneNumberLookup;
